module.exports = __webpack_public_path__ + "static/waltz-krem-rolls-cokoladni-0e26dfd550652fe98866be23dd7b74b8.jpg";